module.exports = __webpack_public_path__ + "img/building-user-solid.c8486785.svg";